import { useEffect, useState } from 'react';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useSubscriptionV2 } from '../../support/state/useSubscriptionV2';
import { CaremapNotesModelFactory } from '../model/CaremapNotesModelFactory';
import { AlertPresenter } from '../../AlertPresenter';
import { MixPanelEventEmitter } from '../../metrics/MixPanelEventEmitter';
import { useRerenderOnUploadChange } from '../generic-notes/attachments/useRerenderOnUploadChange';

interface IUseNoteEditorParams {
    noteId: string;
    trackingFrom?: string;
    onSaved?: () => void;
}

export const useNoteEditor = ({ noteId, trackingFrom, onSaved }: IUseNoteEditorParams) => {
    const notesFactory = useInstance(CaremapNotesModelFactory);
    const alert = useInstance(AlertPresenter);
    const tracking = useInstance(MixPanelEventEmitter);

    useRerenderOnUploadChange();

    const noteVM = useSubscriptionV2(async () => await notesFactory.createEditForm(noteId));

    const [initialPrivacy, setInitialPrivacy] = useState<boolean>();
    useEffect(() => {
        if (noteVM) {
            setInitialPrivacy(noteVM.getNote().isPrivate);
        }
    }, [noteVM]);

    const saveAndClose = async () => {
        if (!noteVM) {
            return;
        }
        try {
            await noteVM.save({ trackingFrom });

            if (initialPrivacy && noteVM.getNote().isPrivate !== initialPrivacy) {
                tracking.track('Note Posted to Community', () => (
                    { 'Method': 'Manually Made Public', 'Is Pinned': notesFactory.notePinsState.isPinned(noteId) }
                ));
            }

            onSaved?.();
        }
        catch (err: any) {
            alert.showAndLogError(err);
        }
    };

    return { noteVM, saveAndClose };
};
